import React from "react"
import {
  createStyles,
  forwardRef,
  HTMLStyledProps,
  styled,
} from "@design-system/core"
import { __DEV__ } from "@design-system/utils"
import { useModalContext } from "./ModalContext"

export interface ModalHeaderProps extends HTMLStyledProps<"header"> {}

const styles = createStyles((theme) => ({
  header: {
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: "0%",
    fontSize: theme.fontSizes.xxxLarge,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.xLarge,
    paddingTop: theme.spaces.spacing32,
    paddingLeft: theme.spaces.spacing32,
    paddingBottom: theme.spaces.spacing16,
    paddingRight: 80,
  },
  widthSmall: {
    fontSize: theme.fontSizes.xLarge,
    lineHeight: theme.lineHeights.large,
    paddingTop: theme.spaces.spacing16,
    paddingLeft: theme.spaces.spacing16,
    paddingBottom: theme.spaces.spacing8,
    paddingRight: 48,
  },
}))

export const ModalHeader = forwardRef<ModalHeaderProps, "header">(
  (props, ref) => {
    const { style, ...others } = props
    const { widthSmall } = useModalContext()
    return (
      <styled.header
        {...others}
        style={[styles.header, widthSmall && styles.widthSmall, style]}
        ref={ref}
      />
    )
  },
)

if (__DEV__) {
  ModalHeader.displayName = "ModalHeader"
}
